import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SystemIcon from '../components/ui/SystemIcon';
import { REQUEST_PREMIERE_URL } from '../config/primaryLinks';
import { flixUi } from '../styles/flixUiTheme';

const HERO_IMAGE = 'https://res.cloudinary.com/da1u9kl5f/image/upload/v1772301494/popcorn-bg_d3y28a.jpg';
const LOGO_IMAGE = 'https://res.cloudinary.com/da1u9kl5f/image/upload/v1770637993/veeflix_pe6wbz.png';
const ABOUT_CARD_IMAGES = [
  'https://res.cloudinary.com/da1u9kl5f/image/upload/v1776831353/SCR-20260422-izvq_pybbzz.png',
  'https://res.cloudinary.com/da1u9kl5f/image/upload/v1776831366/SCR-20260422-izvq_tlm0po.png',
  'https://res.cloudinary.com/da1u9kl5f/image/upload/v1772306924/demo-mobile-003_tieko4.png',
];

const DEMOS = [
  {
    title: 'Wedding',
    image: 'https://res.cloudinary.com/da1u9kl5f/image/upload/v1776831265/coming_soon_hbhe0o.jpg',
  },
  {
    title: 'Travel Album',
    image: 'https://res.cloudinary.com/da1u9kl5f/image/upload/v1776831516/coming_soon_red_kv2c3p.jpg',
  },
  {
    title: 'Baby\u2019s First Year',
    image: 'https://res.cloudinary.com/da1u9kl5f/image/upload/v1776831265/coming_soon_hbhe0o.jpg',
  },
];

const HOW_IT_WORKS_STEPS = [
  {
    step: '01',
    title: 'Share Your Moments',
    description: 'Upload your photos, videos, and stories.',
    icon: 'upload',
  },
  {
    step: '02',
    title: 'We Craft Your Premiere',
    description: 'Our team curates and designs your memory stream.',
    icon: 'wand-2',
  },
  {
    step: '03',
    title: 'Receive Your Private Link',
    description: 'Secure. Invite-only. Ready to watch.',
    icon: 'lock',
  },
];

const LIFE_MOMENTS_FEATURES = [
  {
    title: 'Done-for-You',
    description: 'No templates. No DIY editing. Your stories, our curation.',
    icon: 'wand-2',
  },
  {
    title: 'Private & Invite-Only',
    description: 'Your premiere is private and secure. Handpick your audience and we will share access.',
    icon: 'lock',
  },
  {
    title: 'Hosted for you',
    description: 'Secure hosting. No subscriptions required.',
    icon: 'cloud',
  },
  {
    title: 'Streaming-style presentation',
    description: 'Because your memories deserve presentation.',
    icon: 'tv',
  },
];

const REVISIT_GENRES = [
  { label: 'Birthdays', icon: 'cake' },
  { label: 'Anniversaries', icon: 'flower' },
  { label: 'First trips', icon: 'plane' },
  { label: 'Personal Journals', icon: 'book' },
  { label: 'Farewells', icon: 'handshake' },
  { label: 'Baby\u2019s first year', icon: 'baby' },
  { label: 'Kids growing up', icon: 'users' },
  { label: 'Festive Celebrations', icon: 'sparkles' },
  { label: 'Year-in-Review', icon: 'video' },
  { label: 'Family Re-union', icon: 'home' },
  { label: 'Weddings', icon: 'ring' },
  { label: 'Baby Showers', icon: 'heart' },
  { label: 'Gifts to a Special Someone', icon: 'gift' },
  { label: 'Graduations', icon: 'graduation-cap' },
  { label: 'Unforgettable Moments', icon: 'star' },
  { label: 'Get-togethers', icon: 'users' },
  { label: 'Christmas', icon: 'tree-pine' },
  { label: 'Diwali', icon: 'sparkles' },
  { label: 'Eid', icon: 'moon' },
];

const TESTIMONIALS = [
  {
    quote: 'I surprised my wife with our own netflix for our 9th anniversary. She absolutely loved it! Thank you, Team Veeflix!',
    name: 'Arjun',
    photoUrl: '',
  },
  {
    quote: 'My friends gifted me my own Niviflix filled with our memories and messages. I will never forget this and will keep coming back to this every year!',
    name: 'Nivedita',
    photoUrl: '',
  },
  {
    quote: 'My daughters made a special Suniflix for my 60th birthday. It brought tears to my eyes. What a wonderful experience. I will cherish this my whole life!',
    name: 'Sunita',
    photoUrl: '',
  },
];

const FAQ = [
  {
    q: 'Is this a subscription?',
    a: 'No. Veeflix is a one-time, project-based service. You pay once per premiere. There are no monthly fees.',
  },
  {
    q: 'How do I share my photos and videos?',
    a: 'After booking, we provide a secure upload link. You can share photos, videos, voice notes, and any context you’d like included. We handle the rest.',
  },
  {
    q: 'How long does it take?',
    a: 'Most premieres are delivered within 5–10 working days, depending on the volume of content. Priority timelines are available for special occasions.',
  },
  {
    q: 'Is my content private and secure?',
    a: 'Yes. Your Veeflix is invite-only and accessible only to approved viewers. We do not publicly distribute or list your content.',
  },
  {
    q: 'Can I add more episodes later?',
    a: 'Yes. You can request additional episodes or updates anytime as an add-on service.',
  },
  {
    q: 'Do you offer refunds?',
    a: 'Because Veeflix is a custom, curated service, payments are non-refundable once work has begun. We do provide revisions within scope to ensure you are satisfied.',
  },
  {
    q: 'Do you accept international payments?',
    a: 'Yes. We accept Indian payments as well as selected international payment options.',
  },
];

function LandingPage() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <main style={{ background: '#050505', color: '#fff', fontFamily: flixUi.fontFamily }}>
      <style>{`
        .vf-home-hero {
          min-height: 100vh;
        }
        .vf-home-hero-bg {
          background-position: center 64%;
        }
        @media (max-width: 1024px) {
          .vf-home-hero {
            min-height: 92vh;
          }
          .vf-home-hero-bg {
            background-position: center 60%;
          }
        }
        @media (max-width: 640px) {
          .vf-home-hero {
            min-height: 88vh;
          }
          .vf-home-hero-bg {
            background-position: center 55%;
          }
        }
        .vf-top-header {
          position: fixed;
          left: 0;
          right: 0;
          top: 0;
          z-index: 14;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.58rem clamp(0.7rem, 2vw, 1.4rem);
          backdrop-filter: blur(10px);
          background: linear-gradient(
            90deg,
            rgba(0,0,0,0.84) 0%,
            rgba(0,0,0,0.68) 18%,
            rgba(0,0,0,0.1) 50%,
            rgba(0,0,0,0.68) 82%,
            rgba(0,0,0,0.84) 100%
          );
        }
        .vf-top-login-wrap {
          display: flex;
          align-items: center;
          gap: 0.62rem;
          flex-wrap: wrap;
          justify-content: flex-end;
        }
        .vf-top-login-text {
          color: rgba(238,243,251,0.92);
          font-size: clamp(0.92rem, 1.3vw, 1.02rem);
          font-weight: 600;
        }
        .vf-login-accent {
          color: #fff;
          text-decoration: none;
          font-size: clamp(0.9rem, 1.3vw, 1rem);
          font-weight: 700;
          border-radius: 8px;
          padding: 0.54rem 0.95rem;
          border: 1px solid rgba(255,82,90,0.7);
          background: linear-gradient(180deg, #ff2a33 0%, #e50914 92%);
          box-shadow: 0 8px 16px rgba(229,9,20,0.34);
          transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
        }
        .vf-cta-btn {
          display: inline-block;
          text-decoration: none;
          color: #fff;
          background: linear-gradient(180deg, #ff2a33 0%, #e50914 92%);
          border: 1px solid rgba(255,82,90,0.7);
          border-radius: 8px;
          box-shadow: 0 9px 18px rgba(229,9,20,0.34);
          transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
          -webkit-tap-highlight-color: transparent;
        }
        .vf-cta-btn:hover,
        .vf-login-accent:hover {
          transform: translateY(-2px);
          filter: brightness(1.06);
          box-shadow: 0 14px 24px rgba(229,9,20,0.42);
        }
        .vf-cta-btn:active,
        .vf-login-accent:active {
          transform: scale(0.98);
          box-shadow: 0 7px 14px rgba(229,9,20,0.3);
        }
        .vf-about-bar {
          position: relative;
          overflow: hidden;
          display: grid;
          grid-template-columns: 1.05fr 0.95fr;
          align-items: center;
          gap: clamp(1rem, 3vw, 2rem);
        }
        .vf-about-stack {
          order: 2;
          position: relative;
          justify-self: end;
          width: clamp(160px, 22vw, 290px);
          aspect-ratio: 0.64;
          pointer-events: none;
          margin-right: clamp(0rem, 0.6vw, 0.45rem);
        }
        .vf-about-copy {
          order: 1;
          max-width: 760px;
        }
        .vf-about-card {
          position: absolute;
          inset: 0;
          border-radius: 10px;
          overflow: hidden;
          border: 1px solid rgba(255,255,255,0.24);
          box-shadow: 0 10px 24px rgba(0,0,0,0.42);
          background-size: cover;
          background-position: center center;
        }
        .vf-about-card:nth-child(1) { transform: translateX(0) scale(1); z-index: 3; }
        .vf-about-card:nth-child(2) { transform: translateX(16%) scale(0.94); z-index: 2; opacity: 0.92; filter: brightness(0.95); }
        .vf-about-card:nth-child(3) { transform: translateX(30%) scale(0.89); z-index: 1; opacity: 0.82; filter: brightness(0.9); }
        @media (max-width: 980px) {
          .vf-about-bar {
            grid-template-columns: 1fr;
            text-align: center;
            gap: 1rem;
          }
          .vf-about-stack {
            justify-self: center;
            margin-right: 0;
            width: min(320px, 86vw);
          }
          .vf-about-copy h2,
          .vf-about-copy p {
            text-align: center !important;
            margin-left: auto;
            margin-right: auto;
          }
          .vf-about-copy a {
            justify-self: center;
          }
        }
        @media (max-width: 860px) {
          .vf-about-stack {
            display: none;
          }
        }
        .vf-demo-header {
          display: grid;
          grid-template-columns: minmax(0, 1fr) minmax(300px, 540px);
          gap: clamp(0.8rem, 2vw, 1.5rem);
          align-items: start;
          margin-bottom: 1rem;
        }
        .vf-demo-headline {
          margin: 0;
          font-size: clamp(1.85rem, 4.6vw, 3.1rem);
          line-height: 1.06;
          letter-spacing: flixUi.titleLetterSpacing;
          font-weight: flixUi.headingWeight;
        }
        .vf-demo-meta {
          max-width: 520px;
          justify-self: start;
        }
        .vf-demo-subtext {
          margin: 0;
          color: #aeb6c7;
          font-size: clamp(1rem, 1.65vw, 1.14rem);
          line-height: 1.5;
        }
        .vf-demo-cta {
          margin-top: 0.8rem;
          font-weight: 700;
          font-size: 0.96rem;
          padding: 0.56rem 0.9rem;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          margin-left: 0.06rem;
        }
        .vf-demo-grid {
          display: grid;
          gap: 0.8rem;
          grid-template-columns: repeat(3, minmax(0, 1fr));
        }
        .vf-demo-card {
          position: relative;
          aspect-ratio: 16 / 9;
          border-radius: 14px;
          overflow: hidden;
          border: 1px solid rgba(255,255,255,0.2);
          background-size: cover;
          background-position: center;
          box-shadow: 0 10px 24px rgba(0,0,0,0.35);
          transition: transform 0.24s ease, box-shadow 0.24s ease, border-color 0.24s ease;
        }
        .vf-demo-card:hover {
          transform: translateY(-4px);
          border-color: rgba(255,255,255,0.34);
          box-shadow: 0 18px 32px rgba(0,0,0,0.45);
        }
        .vf-demo-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(to top, rgba(0,0,0,0.78) 12%, rgba(0,0,0,0.32) 50%, rgba(0,0,0,0.1) 100%);
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          padding: 0.7rem;
        }
        .vf-demo-title {
          margin: 0 0 0.5rem;
          font-size: clamp(1rem, 2vw, 1.24rem);
          letter-spacing: 0.25px;
          font-weight: 700;
          text-shadow: 0 3px 10px rgba(0,0,0,0.7);
        }
        .vf-demo-flag {
          align-self: flex-start;
          display: inline-flex;
          align-items: center;
          min-height: 1.72rem;
          padding: 0.16rem 0.68rem 0.18rem;
          border-radius: 4px;
          color: #fff;
          font-size: 0.86rem;
          font-weight: 800;
          letter-spacing: 0.2px;
          line-height: 1;
          background: linear-gradient(180deg, #ff2a2a 0%, #e50914 100%);
          box-shadow: 0 5px 10px rgba(229,9,20,0.35);
        }
        .vf-how-grid {
          display: grid;
          gap: 0.9rem;
          grid-template-columns: repeat(3, minmax(0, 1fr));
        }
        .vf-how-card {
          position: relative;
          display: flex;
          overflow: hidden;
          border-radius: 14px;
          border: 1px solid rgba(255,255,255,0.18);
          background: linear-gradient(145deg, rgba(255,255,255,0.03), rgba(255,255,255,0.01));
          min-height: 230px;
          padding: 1rem 1rem 1rem 1.2rem;
        }
        .vf-how-step {
          position: absolute;
          left: 0.56rem;
          top: 0.36rem;
          font-size: clamp(2.8rem, 7.3vw, 4.8rem);
          font-weight: 700;
          line-height: 1;
          color: transparent;
          -webkit-text-stroke: 1.3px rgba(255,255,255,0.42);
          opacity: 0.85;
          pointer-events: none;
          letter-spacing: 1px;
        }
        .vf-how-content {
          position: relative;
          z-index: 1;
          margin-top: auto;
          padding-bottom: 0.2rem;
        }
        .vf-how-icon-wrap {
          position: absolute;
          top: 0.95rem;
          right: 0.95rem;
          width: 56px;
          height: 56px;
          border-radius: 999px;
          border: 1px solid rgba(255,255,255,0.2);
          background: radial-gradient(100% 100% at 35% 25%, rgba(229,9,20,0.18), rgba(255,255,255,0.02));
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
        .vf-how-title {
          margin: 0;
          font-size: clamp(1.08rem, 2.1vw, 1.34rem);
          line-height: 1.28;
          font-weight: 700;
        }
        .vf-how-copy {
          margin: 0.36rem 0 0;
          color: #b7becc;
          font-size: clamp(0.98rem, 1.55vw, 1.12rem);
          line-height: 1.5;
          max-width: 34ch;
        }
        .vf-life-wrap {
          padding: 0;
        }
        .vf-life-intro {
          display: grid;
          grid-template-columns: minmax(0, 1fr) minmax(300px, 600px);
          gap: clamp(0.8rem, 2.2vw, 1.8rem);
          align-items: start;
        }
        .vf-life-intro-title {
          margin-top: 0;
          margin-bottom: 0.55rem;
          font-size: clamp(1.85rem, 4.6vw, 3.1rem);
          line-height: 1.06;
          letter-spacing: flixUi.titleLetterSpacing;
          font-weight: flixUi.headingWeight;
        }
        .vf-life-intro-copy {
          margin-top: 0;
          margin-bottom: 0;
          max-width: 860px;
          color: #c2c8d3;
          line-height: 1.5;
          font-size: clamp(1rem, 1.7vw, 1.18rem);
        }
        .vf-life-grid {
          display: grid;
          gap: 1rem;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          margin-top: 1.2rem;
        }
        .vf-life-item {
          border-radius: 12px;
          border: 1px solid rgba(255,255,255,0.14);
          background: linear-gradient(165deg, rgba(255,255,255,0.045), rgba(255,255,255,0.012));
          padding: 1.25rem 1.15rem;
          min-height: 198px;
        }
        .vf-life-icon {
          width: 54px;
          height: 54px;
          border-radius: 999px;
          background: #fff;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 0.65rem;
          box-shadow: 0 8px 18px rgba(0,0,0,0.35);
        }
        .vf-life-title {
          margin: 0;
          font-size: 1.01rem;
          line-height: 1.35;
          font-weight: 700;
        }
        .vf-life-copy {
          margin: 0.42rem 0 0;
          color: #b7becc;
          font-size: clamp(0.98rem, 1.55vw, 1.12rem);
          line-height: 1.5;
        }
        .vf-revisit-wrap {
          border-radius: 14px;
          padding: clamp(1.05rem, 2.8vw, 1.35rem) 0;
          background:
            radial-gradient(95% 150% at 92% 20%, rgba(132,10,24,0.54), rgba(96,8,18,0.28) 35%, rgba(0,0,0,0) 70%),
            linear-gradient(180deg, rgba(0,0,0,0.88), rgba(0,0,0,0.92));
        }
        .vf-revisit-header {
          display: grid;
          grid-template-columns: 1fr;
          gap: clamp(0.8rem, 2.2vw, 1.6rem);
          align-items: start;
        }
        .vf-revisit-title {
          margin: 0;
          font-size: clamp(1.85rem, 4.6vw, 3.1rem);
          line-height: 1.06;
          letter-spacing: flixUi.titleLetterSpacing;
          font-weight: flixUi.headingWeight;
          white-space: nowrap;
        }
        .vf-revisit-subtext {
          margin: 0;
          color: #b7becc;
          max-width: 56ch;
          font-size: clamp(1rem, 1.65vw, 1.14rem);
          line-height: 1.5;
        }
        .vf-revisit-scroller {
          margin-top: 1rem;
          overflow-x: auto;
          overflow-y: hidden;
          padding: 0 0.1rem 0.35rem;
          scrollbar-width: thin;
        }
        .vf-revisit-grid {
          display: grid;
          gap: 0.7rem;
          grid-template-rows: repeat(3, minmax(52px, auto));
          grid-auto-flow: column;
          grid-auto-columns: minmax(220px, 280px);
          width: max-content;
        }
        .vf-revisit-pill {
          border-radius: 999px;
          border: 1px solid rgba(255,255,255,0.16);
          background: linear-gradient(130deg, rgba(255,255,255,0.03), rgba(255,255,255,0.01));
          min-height: 58px;
          padding: 0.52rem 0.86rem;
          display: inline-flex;
          align-items: center;
          gap: 0.62rem;
        }
        .vf-revisit-pill-icon {
          width: 30px;
          height: 30px;
          border-radius: 999px;
          background: #fff;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .vf-revisit-pill-label {
          color: #eceff6;
          font-size: 1rem;
          font-weight: 600;
          line-height: 1.2;
        }
        .vf-love-headline {
          margin-top: 0;
          margin-bottom: 0.55rem;
          font-size: clamp(1.85rem, 4.6vw, 3.1rem);
          letter-spacing: flixUi.titleLetterSpacing;
          font-weight: flixUi.headingWeight;
        }
        .vf-love-subline {
          margin-top: 0;
          color: #b7becc;
          font-size: clamp(1rem, 1.65vw, 1.14rem);
          line-height: 1.5;
        }
        .vf-love-grid {
          margin-top: 1.35rem;
          display: grid;
          gap: 0.95rem;
          grid-template-columns: repeat(3, minmax(0, 1fr));
        }
        .vf-love-card {
          border-radius: 14px;
          border: 1px solid rgba(255,255,255,0.17);
          background: linear-gradient(160deg, rgba(255,255,255,0.04), rgba(255,255,255,0.015));
          padding: 1.05rem 1rem;
          min-height: 260px;
          display: flex;
          flex-direction: column;
        }
        .vf-love-quote {
          margin: 0;
          color: #e9edf6;
          font-size: clamp(1rem, 1.55vw, 1.1rem);
          line-height: 1.54;
          flex: 1;
        }
        .vf-love-meta {
          margin-top: 0.9rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 0.7rem;
        }
        .vf-love-name {
          color: #f7f9fc;
          font-size: 0.98rem;
          font-weight: 700;
          letter-spacing: 0.2px;
        }
        .vf-love-heart {
          width: 34px;
          height: 34px;
          border-radius: 999px;
          background: radial-gradient(100% 100% at 35% 35%, rgba(255,74,86,0.95), rgba(229,9,20,0.92));
          box-shadow: 0 7px 14px rgba(229,9,20,0.34);
          display: inline-flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 0.9rem;
          font-weight: 700;
          overflow: hidden;
          flex-shrink: 0;
        }
        .vf-love-heart img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .vf-pricing-card {
          max-width: 940px;
          margin: 0 auto;
          border-radius: 16px;
          border: 1px solid rgba(255,255,255,0.2);
          background:
            radial-gradient(85% 140% at 16% 10%, rgba(229,9,20,0.28), rgba(229,9,20,0.02) 52%, rgba(255,255,255,0.02) 100%),
            linear-gradient(145deg, rgba(255,255,255,0.04), rgba(255,255,255,0.015));
          padding: clamp(1.55rem, 4.8vw, 2.8rem) clamp(1.2rem, 4vw, 2.2rem);
          text-align: center;
        }
        .vf-pricing-title {
          margin-top: 0;
          margin-bottom: 1rem;
          font-size: clamp(1.9rem, 4.7vw, 3.12rem);
          line-height: 1.06;
          letter-spacing: flixUi.titleLetterSpacing;
          font-weight: flixUi.headingWeight;
        }
        .vf-pricing-line {
          margin: 0.28rem 0;
          color: #f5f8fc;
          font-size: clamp(1rem, 1.65vw, 1.14rem);
          line-height: 1.5;
        }
        .vf-pricing-price {
          margin: 0.9rem 0 0.65rem;
          color: #fff;
          font-size: clamp(1.3rem, 3vw, 1.8rem);
          font-weight: 800;
        }
        .vf-pricing-includes {
          margin: 1rem auto 0;
          max-width: 820px;
          text-align: center;
          color: #dde3ef;
          line-height: 1.5;
          font-size: clamp(0.98rem, 1.5vw, 1.08rem);
        }
        .vf-pricing-includes p {
          margin: 0;
          font-weight: 700;
          color: #f0f3fa;
          white-space: nowrap;
        }
        .vf-pricing-includes ul {
          margin: 0.45rem 0 0;
          padding-left: 1.05rem;
        }
        .vf-pricing-includes li {
          margin: 0.18rem 0;
        }
        .vf-faq-layout {
          display: grid;
          grid-template-columns: minmax(180px, 360px) minmax(0, 1fr);
          gap: clamp(1rem, 3vw, 2.4rem);
          align-items: start;
        }
        .vf-faq-heading {
          margin: 0;
          font-size: clamp(1.95rem, 4.9vw, 3.35rem);
          line-height: 1.02;
          letter-spacing: flixUi.titleLetterSpacing;
          font-weight: flixUi.headingWeight;
          max-width: 10ch;
        }
        .vf-section-title {
          margin-top: 0;
          margin-bottom: 0.7rem;
          font-size: clamp(1.85rem, 4.6vw, 3.1rem);
          line-height: 1.06;
          letter-spacing: flixUi.titleLetterSpacing;
          font-weight: flixUi.headingWeight;
        }
        .vf-section-subtext {
          margin-top: 0;
          color: #b7becc;
          font-size: clamp(1rem, 1.65vw, 1.14rem);
          line-height: 1.5;
        }
        .vf-final-wrap {
          max-width: 980px;
          margin: 0 auto;
          text-align: center;
          border-radius: 16px;
          border: 1px solid rgba(255,255,255,0.18);
          background:
            radial-gradient(85% 140% at 84% 16%, rgba(229,9,20,0.3), rgba(229,9,20,0.04) 52%, rgba(255,255,255,0.02)),
            linear-gradient(150deg, rgba(255,255,255,0.035), rgba(255,255,255,0.012));
          padding: clamp(1.3rem, 4vw, 2.1rem);
        }
        .vf-final-title {
          margin-top: 0;
          margin-bottom: 0.55rem;
          font-size: clamp(1.85rem, 4.6vw, 3.1rem);
          line-height: 1.06;
          letter-spacing: flixUi.titleLetterSpacing;
          font-weight: flixUi.headingWeight;
        }
        .vf-final-note {
          margin-top: 0.68rem;
          color: #9aa3b2;
          font-size: 0.98rem;
        }
        .vf-faq-item {
          border-bottom: 1px solid rgba(255,255,255,0.18);
        }
        .vf-faq-btn {
          width: 100%;
          border: 0;
          background: transparent;
          color: #fff;
          text-align: left;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 0.8rem;
          padding: 1.02rem 0.1rem;
          cursor: pointer;
        }
        .vf-faq-q {
          font-size: clamp(1.02rem, 1.5vw, 1.45rem);
          font-weight: 700;
          line-height: 1.24;
        }
        .vf-faq-icon {
          width: 34px;
          height: 34px;
          border-radius: 999px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          border: 1px solid rgba(255,255,255,0.35);
          background: rgba(245,248,252,0.96);
          color: #4b5563;
        }
        .vf-faq-icon--open {
          background: rgba(255,255,255,0.98);
          color: #e50914;
          border-color: rgba(229,9,20,0.5);
        }
        .vf-faq-glyph {
          font-size: 1.25rem;
          line-height: 1;
          font-weight: 700;
        }
        .vf-faq-answer {
          margin: 0 0 1.15rem;
          color: #b8beca;
          line-height: 1.52;
          font-size: clamp(0.98rem, 1.5vw, 1.1rem);
          max-width: 68ch;
        }
        @media (max-width: 960px) {
          .vf-demo-grid {
            grid-template-columns: 1fr;
          }
          .vf-demo-header {
            grid-template-columns: 1fr;
            align-items: start;
          }
          .vf-demo-meta {
            max-width: 100%;
          }
          .vf-how-grid {
            grid-template-columns: 1fr;
          }
          .vf-how-card {
            min-height: 205px;
          }
          .vf-life-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
          .vf-revisit-header {
            grid-template-columns: 1fr;
          }
          .vf-life-intro {
            grid-template-columns: 1fr;
          }
          .vf-revisit-title {
            white-space: normal;
          }
          .vf-love-grid {
            grid-template-columns: 1fr;
          }
          .vf-love-card {
            min-height: 210px;
          }
          .vf-faq-layout {
            grid-template-columns: 1fr;
          }
          .vf-faq-heading {
            max-width: none;
            margin-bottom: 0.4rem;
          }
          .vf-pricing-includes p {
            white-space: normal;
          }
        }
        @media (max-width: 680px) {
          .vf-life-grid {
            grid-template-columns: 1fr;
          }
          .vf-revisit-grid {
            grid-auto-columns: minmax(190px, 235px);
          }
          .vf-demo-subtext,
          .vf-how-copy,
          .vf-life-copy,
          .vf-revisit-subtext {
            font-size: 1rem;
            line-height: 1.56;
          }
          .vf-how-title,
          .vf-life-title {
            line-height: 1.32;
          }
          .vf-top-login-wrap {
            gap: 0.5rem;
          }
          .vf-top-login-text {
            font-size: 0.88rem;
          }
          .vf-section-title,
          .vf-final-title {
            font-size: clamp(1.72rem, 7.1vw, 2.5rem);
          }
        }
      `}</style>

      <section
        className="vf-home-hero"
        style={{
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 'clamp(1rem, 4vw, 2rem)',
        }}
      >
        <div
          className="vf-home-hero-bg"
          style={{
            position: 'absolute',
            inset: 0,
            backgroundImage: `url(${HERO_IMAGE})`,
            backgroundSize: 'cover',
            transform: 'scale(1.03)',
          }}
        />
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(0,0,0,0.22), rgba(0,0,0,0.62))' }} />
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(62% 36% at 52% 71%, rgba(255,220,180,0.34), rgba(255,220,180,0.08) 46%, rgba(255,220,180,0) 75%)' }} />
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(130% 110% at 50% 52%, rgba(0,0,0,0) 32%, rgba(0,0,0,0.56) 70%, rgba(0,0,0,0.86) 100%)' }} />

        <header className="vf-top-header">
          <img src={LOGO_IMAGE} alt="Veeflix" style={{ height: 'clamp(30px, 4vw, 48px)', width: 'auto' }} />
          <div className="vf-top-login-wrap">
            <span className="vf-top-login-text">
              Already have a premiere?
            </span>
            <Link
              to="/login"
              className="vf-login-accent"
            >
              Login
            </Link>
          </div>
        </header>

        <div style={{ position: 'relative', zIndex: 2, width: '100%', maxWidth: 1180, textAlign: 'center' }}>
          <h1
            style={{
              margin: 0,
              fontSize: 'clamp(1.7rem, 4.7vw, 3.8rem)',
              lineHeight: 1.04,
              letterSpacing: flixUi.titleLetterSpacing,
              fontWeight: 600,
            }}
          >
            Turn your photos into a cinematic memory experience
          </h1>
          <p style={{ margin: '0.9rem auto 0', maxWidth: 760, color: 'rgba(232,236,244,0.9)', fontSize: 'clamp(1rem, 2.2vw, 1.3rem)' }}>
            Your popcorn worthy moments deserve more than a drive link.
          </p>
          <a
            href={REQUEST_PREMIERE_URL}
            target="_blank"
            rel="noreferrer"
            className="vf-cta-btn"
            style={{
              marginTop: '1.2rem',
              padding: '0.82rem 1.18rem',
              fontWeight: 700,
              fontSize: '1rem',
            }}
          >
            Get Your Own Premiere
          </a>
        </div>
      </section>

      <section style={{ background: '#000', padding: '1.4rem clamp(0.6rem, 2vw, 1.4rem) 1.2rem' }}>
        <div
          className="vf-about-bar"
          style={{
            maxWidth: 1240,
            margin: '0 auto',
            minHeight: 'clamp(240px, 31vw, 340px)',
            background: 'linear-gradient(90deg, rgba(229,9,20,0.12), rgba(0,0,0,0.9) 34%, rgba(0,0,0,0.98) 100%)',
            padding: 'clamp(0.85rem, 2vw, 1.35rem) clamp(1rem, 4vw, 2rem)',
          }}
        >
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background: 'radial-gradient(40% 78% at 76% 52%, rgba(255,255,255,0.1), rgba(0,0,0,0) 65%)',
            }}
          />
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background: 'radial-gradient(130% 100% at 50% 50%, rgba(0,0,0,0) 48%, rgba(0,0,0,0.58) 88%, rgba(0,0,0,0.84) 100%)',
            }}
          />
          <div className="vf-about-copy" style={{ position: 'relative', zIndex: 1 }}>
            <h2
              style={{
                margin: 0,
                color: '#f2f5fb',
                textAlign: 'left',
                fontSize: 'clamp(1.25rem, 2.35vw, 2rem)',
                lineHeight: 1.28,
                letterSpacing: flixUi.titleLetterSpacing,
                fontWeight: 600,
                maxWidth: 700,
              }}
            >
              <span
                style={{
                  color: '#e50914',
                  fontWeight: 900,
                  letterSpacing: 1,
                  marginRight: 10,
                  display: 'inline-block',
                  transform: 'skew(-5deg)',
                  textShadow: '0 0 16px rgba(229,9,20,0.18)',
                }}
              >
                VEEFLIX
              </span>
              turns your photos and videos into a private, streaming-style memory experience - curated, hosted, and delivered for you.
            </h2>
          </div>
          <div className="vf-about-stack">
            {ABOUT_CARD_IMAGES.map((src) => (
              <div
                key={src}
                className="vf-about-card"
                style={{ backgroundImage: `url(${src})` }}
              />
            ))}
          </div>
        </div>
      </section>

      <section style={{ padding: 'clamp(2rem, 6vw, 4rem) clamp(0.6rem, 2vw, 1.4rem) 0' }}>
        <div style={{ maxWidth: 1240, margin: '0 auto' }}>
          <div className="vf-demo-header">
            <h2 className="vf-demo-headline">Experience the Magic</h2>
            <div className="vf-demo-meta">
              <p className="vf-demo-subtext">Click on a premiere for a special preview</p>
            <a
              href={REQUEST_PREMIERE_URL}
              target="_blank"
              rel="noreferrer"
              className="vf-demo-cta vf-cta-btn"
            >
              Request Demo
              <span aria-hidden="true">&gt;</span>
            </a>
            </div>
          </div>
          <div className="vf-demo-grid">
            {DEMOS.map((item) => (
              <a
                key={item.title}
                href={REQUEST_PREMIERE_URL}
                target="_blank"
                rel="noreferrer"
                className="vf-demo-card"
                style={{
                  textDecoration: 'none',
                  color: '#fff',
                  backgroundImage: `url(${item.image})`,
                }}
              >
                <div className="vf-demo-overlay">
                  <strong className="vf-demo-title">{item.title}</strong>
                  <span className="vf-demo-flag">Special Preview</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      <section style={{ padding: 'clamp(2rem, 6vw, 4rem) clamp(0.6rem, 2vw, 1.4rem) 0' }}>
        <div style={{ maxWidth: 1240, margin: '0 auto' }}>
          <h2 className="vf-section-title">
            How it works
          </h2>
          <div className="vf-how-grid">
            {HOW_IT_WORKS_STEPS.map((item) => (
              <article key={item.step} className="vf-how-card">
                <span className="vf-how-step">{item.step}</span>
                <div className="vf-how-icon-wrap">
                  <SystemIcon icon={item.icon} size={34} alt="" tone="red" />
                </div>
                <div className="vf-how-content">
                  <h3 className="vf-how-title">{item.title}</h3>
                  <p className="vf-how-copy">{item.description}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section
        style={{
          padding: 'clamp(3rem, 7vw, 5rem) clamp(0.6rem, 2vw, 1.4rem) clamp(2.2rem, 6vw, 4.4rem)',
          background:
            'linear-gradient(180deg, rgba(5,5,5,1) 0%, rgba(5,5,5,0.98) 18%, rgba(64,6,15,0.24) 46%, rgba(0,0,0,0) 82%), radial-gradient(120% 150% at 14% 28%, rgba(146,12,26,0.34) 0%, rgba(88,7,18,0.2) 42%, rgba(0,0,0,0) 78%), #050505',
        }}
      >
        <div style={{ maxWidth: 1240, margin: '0 auto' }}>
          <div className="vf-life-wrap">
            <div className="vf-life-intro">
              <h2 className="vf-life-intro-title">
                Your Life, Your Moments
                <br />
                Deserve to be Streamed
              </h2>
              <p className="vf-life-intro-copy">
                Veeflix curators craft each story you want to tell for your big screen moment. You are the director, we are the editors.
              </p>
            </div>
            <div className="vf-life-grid">
              {LIFE_MOMENTS_FEATURES.map((item) => (
                <article key={item.title} className="vf-life-item">
                  <div className="vf-life-icon">
                    <SystemIcon icon={item.icon} size={24} alt="" tone="red" />
                  </div>
                  <h3 className="vf-life-title">{item.title}</h3>
                  <p className="vf-life-copy">{item.description}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: 'clamp(2rem, 6vw, 4rem) clamp(0.6rem, 2vw, 1.4rem) 0' }}>
        <div style={{ maxWidth: 1320, margin: '0 auto' }}>
          <div className="vf-revisit-wrap">
            <div className="vf-revisit-header">
              <h2 className="vf-revisit-title">Revisit the moments that made you</h2>
              <p className="vf-revisit-subtext">
                Late nights. Old jokes. The people who stayed. Your memories deserve more than a scroll.
              </p>
            </div>
            <div className="vf-revisit-scroller">
              <div className="vf-revisit-grid">
                {REVISIT_GENRES.map((genre) => (
                  <div key={genre.label} className="vf-revisit-pill">
                    <span className="vf-revisit-pill-icon">
                      <SystemIcon icon={genre.icon} size={14} alt="" tone="red" />
                    </span>
                    <span className="vf-revisit-pill-label">{genre.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: 'clamp(2rem, 6vw, 4rem) clamp(0.6rem, 2vw, 1.4rem) 0' }}>
        <div style={{ maxWidth: 1320, margin: '0 auto' }}>
          <h2 className="vf-love-headline">
            Wall of Love
          </h2>
          <p className="vf-love-subline">When we share the love, it comes back multifold &lt;3</p>
          <div className="vf-love-grid">
            {TESTIMONIALS.map((item) => (
              <article key={item.name} className="vf-love-card">
                <p className="vf-love-quote">{item.quote}</p>
                <div className="vf-love-meta">
                  <span className="vf-love-name">{item.name}</span>
                  <span className="vf-love-heart" aria-hidden="true">
                    {item.photoUrl ? <img src={item.photoUrl} alt={item.name} /> : <span>♥</span>}
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section style={{ padding: 'clamp(2rem, 6vw, 4rem) clamp(0.6rem, 2vw, 1.4rem) 0' }}>
        <div className="vf-pricing-card">
          <h2 className="vf-pricing-title">
            One Premiere.
            <br />
            Upto 50 memories.
          </h2>
          <p className="vf-pricing-price">
            Starting at ₹4,999
          </p>
          <p className="vf-pricing-line">
            Perfect for gifting, anniversaries, birthdays & milestone celebrations.
          </p>
          <div className="vf-pricing-includes">
            <p>Includes: Curated, cinematic design • Private, secure hosting • Invite-only access</p>
          </div>
          <a
            href={REQUEST_PREMIERE_URL}
            target="_blank"
            rel="noreferrer"
            className="vf-cta-btn"
            style={{
              marginTop: '1rem',
              padding: '0.84rem 1.2rem',
              fontWeight: 700,
              fontSize: '1rem',
            }}
          >
            Request Your Premiere
          </a>
        </div>
      </section>

      <section style={{ padding: 'clamp(3.3rem, 9vw, 5.4rem) clamp(0.6rem, 2vw, 1.4rem) 0' }}>
        <div style={{ maxWidth: 1320, margin: '0 auto' }} className="vf-faq-layout">
          <h2 className="vf-faq-heading">
            Frequently
            <br />
            Asked
            <br />
            Questions
          </h2>
          <div>
            {FAQ.map((item, index) => {
              const open = openFaq === index;
              return (
                <article key={item.q} className="vf-faq-item">
                  <button
                    type="button"
                    onClick={() => setOpenFaq(open ? -1 : index)}
                    className="vf-faq-btn"
                  >
                    <span className="vf-faq-q">{item.q}</span>
                    <span className={`vf-faq-icon ${open ? 'vf-faq-icon--open' : ''}`}>
                      <span className="vf-faq-glyph" aria-hidden="true">{open ? '×' : '+'}</span>
                    </span>
                  </button>
                  {open ? <p className="vf-faq-answer">{item.a}</p> : null}
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <section style={{ padding: 'clamp(1.9rem, 6vw, 4rem) clamp(0.6rem, 2vw, 1.4rem) clamp(2.3rem, 8vw, 4.2rem)' }}>
        <div className="vf-final-wrap">
          <h2 className="vf-final-title">
            Ready to Premiere Your Story?
          </h2>
          <a
            href={REQUEST_PREMIERE_URL}
            target="_blank"
            rel="noreferrer"
            className="vf-cta-btn"
            style={{
              padding: '0.9rem 1.28rem',
              fontWeight: 700,
              fontSize: '1rem',
            }}
          >
            Request your Veeflix
          </a>
          <p className="vf-final-note">
            Takes less than 2 minutes to request.
          </p>
        </div>
      </section>
    </main>
  );
}

export default LandingPage;
